import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CommonService } from './common.service';
import { ConsumeView, DataPackCompanyDetail, DataPackGroup, DataPackUserManagerModel, DataPackLine, DataPackValue } from 'app/models/start';
import { ConsumeService } from './consume.service';
import { BindComponentService } from '../utils/bind.component.service';

/**
 * @author Wesley Mascarenhas
 * @version $Id: consume.service.ts 71155 2017-11-23 04:02:37Z thiago.h.neri $
 */
@Injectable()
export class VoiceConsumeService extends CommonService {
  private localURL: string;
  private VOICE_CONSUMER_PATH: string = '/voiceconsumption';

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.VOICE_CONSUMER_PATH;
  }

  public  Groups(startRow: number, fetchSize: number,hasOverBalanceMonetaryVoice:boolean,hasHibridService:boolean) {
    return this.loadGroups(startRow, fetchSize,hasOverBalanceMonetaryVoice,hasHibridService);
  }


  public getFranchiseAvailableVoice() {
    let url = this.localURL + '?action=franchiseAvailableVoice';
    return this.convertResponse(this.httpGet(url));
  }

  public loadGroups(startRow: number, fetchSize: number,hasOverBalanceMonetaryVoice:boolean,hasHibridService:boolean) {
    return this.convertResponse(this.httpPost(this.localURL,{action:'listGroups',startRow:startRow,fetchSize:fetchSize,hasOverBalanceMonetaryVoice:hasOverBalanceMonetaryVoice,hasHibridService:hasHibridService}));
  }

  public loadingLines(group:DataPackGroup,startRow: number, fetchSize: number,hasOverBalanceMonetaryVoice:boolean,hasHibridService:boolean, lineTypeFilter='T') {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'loadingLines',startRow:startRow,fetchSize:fetchSize,hasOverBalanceMonetaryVoice:hasOverBalanceMonetaryVoice,hasHibridService:hasHibridService,lineTypeFilter:lineTypeFilter}));
  }

  public listLines(group: DataPackGroup, startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=listLines'
    if(group) {
      url += '&groupId=' + group.id;
    }
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public activateSmsNotification(numberOfDays: string) {
    let url = this.localURL + '?action=activateSmsNotification';
    if(null != numberOfDays) {
      url += '&numberOfDays=' + numberOfDays;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public updateSharedLimits(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }
  
  public updateSharedOverBalance(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }


  public searchLines(startRow: number, fetchSize: number,filter:string) {
    let url = this.localURL + '?action=searchLines';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize + '&filter=' + filter;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public countSearchLines(startRow: number, fetchSize: number,filter:string) {
    let url = this.localURL + '?action=countSearchLines';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    if(fetchSize >= 0) {
      url += '&filter=' + filter;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public loadGroupFilterVoice(group:DataPackGroup,startRow: number, fetchSize: number,hasOverBalanceMonetaryVoice:boolean,hasHibridService:boolean) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'loadSelectedLineAndGroup',startRow:startRow,fetchSize:fetchSize,hasOverBalanceMonetaryVoice:hasOverBalanceMonetaryVoice,hasHibridService:hasHibridService}));
  }

  public loadView(startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=loadView';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public save(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }

  public getGroupMoveLines(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }

  public configureLimitAndExceedInBatch(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }

  public getBatchStatus(group:DataPackGroup) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'getBatchStatus'}));
  }

  public finishBatchStatus(group:DataPackGroup) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'finishBatchStatus'}));
  }
}


// WEBPACK FOOTER //
// ./src/app/services/voice.consume.service.ts